// extracted by mini-css-extract-plugin
export default {"register__holder":"ryoFrFn5V7Xz2Eto20tp","register__input":"sd9lku11z7Y1lf_IX5rY","register__button":"QWbooWA_w1_cvL0LORWU","register__help":"ELw7J8wspCkqy5Q6RECm"};